import { render } from "./OnlyHeaderLayout.vue?vue&type=template&id=055d683c&bindings={}"
import script from "./OnlyHeaderLayout.vue?vue&type=script&lang=js"
export * from "./OnlyHeaderLayout.vue?vue&type=script&lang=js"
script.render = render

export default script